<template>
  <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" persistent width="290px">
    <template v-slot:activator="{ on }">
      <v-form ref="form" v-model="valid">
        <v-text-field
          v-model="dateFormatted"
          :label="label"
          prepend-icon="mdi-calendar"
          readonly
          v-on="on"
          hint="DD/MM/YYYY format"
          clearable
          :rules="required ? $isRequiredRule : []"
        ></v-text-field>
      </v-form>
    </template>

    <v-date-picker v-model="date" scrollable>
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="modal = false">{{$t("cancel")}}</v-btn>
      <v-btn text color="primary" @click="changeDate(date)">{{$t("confirm")}}</v-btn>
    </v-date-picker>
  </v-dialog>
</template>
<script>
import moment from "moment";
export default {
  props: ["value", "label", "format", "required"],
  data() {
    return {
      date: "",
      valid: true,
      modal: false,
      dateFormatted: ""
    };
  },
  watch: {
    value() {
      this.updateDateFormatted();
      this.$refs.form.resetValidation();
    },
    date(value) {
      if (!this.date) return "";
      this.dateFormatted = !this.format
        ? this.date
        : moment(moment(value).toDate()).format(this.format);
    }
  },
  methods: {

    updateDateFormatted(){
            if (this.value == null) {
        (this.date = ""), (this.dateFormatted = "");
        return;
      }
      this.date = moment(this.value).format("YYYY-MM-DD");
 if (!this.date) return ;
      this.dateFormatted = !this.format
        ? this.date
        : moment(moment(this.date).toDate()).format(this.format);
    },
    isValid() {
      return this.$refs.form.validate();
    },
    changeDate(value) {
      this.$refs.dialog.save(value);
      this.$emit("changeDate", value);
      this.$emit("input", value);
    },
    now() {
      return moment(Date.now()).format("YYYY-MM-DD");
    }
  },
  mounted() {
    this.updateDateFormatted();
   // this.date = moment(this.value).format("YYYY-MM-DD");
  }
};
</script>